import React, { useCallback, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Spinner from './Spinner';
import AppTopBar from './AppTopBar';
import BackButton from './BackButton';
import AnalyticsView from './AnalyticsView';
import './Analytics.css';

// The customer's own analytics page: auth guard, page chrome, and the
// fetch. The rendering itself lives in AnalyticsView.js, shared with the
// admin detail view's Complete Analytics section so both show the same
// thing.
const Analytics = ({ isAuth, loading }) => {
  const [status, setStatus] = useState('loading'); // loading | ready | error
  const [errorMsg, setErrorMsg] = useState('');
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    setStatus('loading');
    try {
      const res = await axios.get('/api/users/analytics');
      setData(res.data);
      setStatus('ready');
    } catch (err) {
      setErrorMsg(
        (err.response && err.response.data && err.response.data.msg) ||
          'Failed to load analytics.'
      );
      setStatus('error');
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (!loading && !isAuth) return <Redirect to="/login" />;
  if (loading) return <Spinner />;

  return (
    <div className="analytics-page">
      {/* Same Bootstrap .container Dashboard.js/EditProfile.js wrap
          AppTopBar in, so the bar renders at an identical width on every
          page -- deliberately not .analytics-page__inner below
          (max-width: 640px), which is narrower and would create a new
          mismatch. */}
      <div className="container" style={{ padding: '0' }}>
        <AppTopBar back={<BackButton to="/edit_profile" />} />
      </div>
      <div className="analytics-page__inner">
        {status === 'loading' && <Spinner />}

        {status === 'error' && <p style={{ color: '#d1453b' }}>{errorMsg}</p>}

        {status === 'ready' && <AnalyticsView data={data} leadsTo="/leads" />}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuth: state.registerUser.isAuth,
  loading: state.registerUser.loading,
});

export default connect(mapStateToProps)(Analytics);
